import { animate, state, style, transition, trigger } from '@angular/animations';

export class ChangeEffectAnimation {
    public static ChangeEffect = trigger('changeEffect', [
        state(
            'initial',
            style({
                transform: 'translateX(-100%)',
            })
        ),
        state(
            'initialReverse',
            style({
                transform: 'translateX(-100%)',
            })
        ),
        state(
            'normal',
            style({
                transform: 'translateX(0)',
            })
        ),
        state(
            'final',
            style({
                transform: 'translateX(100%)',
            })
        ),
        state(
            'finalReverse',
            style({
                transform: 'translateX(100%)',
            })
        ),
        transition('initial=>normal', animate('200ms ease-in')),
        transition('normal=>final', animate('200ms ease-out')),
        transition('final=>initial', animate('0ms')),

        transition('finalReverse=>normal', animate('200ms ease-in')),
        transition('normal=>initialReverse', animate('200ms ease-out')),
        transition('initialReverse=>finalReverse', animate('0ms')),
    ]);

    public static ChangeEffectFade = trigger('changeEffectFade', [
        state(
            'initial',
            style({
                opacity: 0,
            })
        ),
        state(
            'normal',
            style({
                opacity: 1,
            })
        ),
        state(
            'final',
            style({
                opacity: 0,
            })
        ),
        transition('initial=>normal', animate('100ms ease-in')),
        transition('normal=>final', animate('100ms ease-out')),
        transition('final=>initial', animate('0ms')),
    ]);

    public static FadeEffect = trigger('fade', [
        transition(':enter', [
            style({ opacity: 0, transform: 'scale(0)' }),
            animate(200, style({ opacity: 1, transform: 'scale(1)' })),
        ]),
        transition(':leave', animate(200, style({ opacity: 0, transform: 'scale(0)' }))),
    ]);

    public static onChangeEffect(initialState: string, $event): string {
        if ($event.phaseName === 'done') {
            if ($event.toState === 'final') {
                return 'initial';
            }
            if ($event.toState === 'initialReverse') {
                return 'finalReverse';
            }
            if ($event.toState === 'initial' || $event.toState === 'finalReverse') {
                return 'normal';
            }
        }
        return initialState;
    }
}
